import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { EmailNav } from './EmailNav';
import { GuidaMailing } from './guida/GuidaMailing';

/**
 * Cornice comune alle schede di Mailing: titolo della sezione,
 * tasto Guida e schede stanno qui una volta sola. Cambiando scheda cambia
 * solo quello che c'e' sotto, e le schede non si spostano mai -- nemmeno
 * mentre la pagina sta ancora caricando.
 */
export function MailingLayout() {
  const posizione = useLocation();
  const [guidaAperta, setGuidaAperta] = useState(false);

  return (
    <div className="space-y-5 md:space-y-6">
      <div>
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            <h1 className="text-2xl md:text-3xl font-bold text-slate-900">Mailing</h1>
            <p className="text-sm text-neutral-400 mt-1">
              Email ai contatti: campagne, sequenze automatiche e modelli
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => setGuidaAperta(true)}
            title="Come funziona Mailing"
            className="h-10 flex-shrink-0 text-neutral-600"
          >
            <HelpCircle className="w-4 h-4 sm:mr-2" />
            <span className="hidden sm:inline">Guida</span>
          </Button>
        </div>

        <div className="mt-4 md:mt-5">
          <EmailNav />
        </div>
      </div>

      <Outlet />

      <GuidaMailing
        aperta={guidaAperta}
        onChiudi={setGuidaAperta}
        percorsoCorrente={posizione.pathname}
      />
    </div>
  );
}
